module.exports = require("./es.d.ts");